import React from 'react';
import { Row } from 'src/common/components/Flex';

export type Props = {
  icon: React.ReactNode;
  size?: number;
  backgroundColor?: string;
  iconColor?: string;
  className?: string;
  radius?: 0 | 2 | 4 | 8 | 12 | 16 | 20 | 24 | 'full';
};

export const IconBackdrop = ({ icon, size = 24, backgroundColor, iconColor, className, radius = 'full' }: Props) => {
  return (
    <Row
      className={`radius-${radius} ${className}`}
      justify="center"
      align="center"
      style={{
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        backgroundColor,
        color: iconColor,
      }}
    >
      {icon}
    </Row>
  );
};

export default IconBackdrop;
